import { GetInsuranceDiscountParams, CreateInsuranceDiscountParams, UpdateInsuranceDiscountParams } from '../../interfaces/InsuranceDiscount';
import { APICore, INSURANCE_URL } from './apiCore';

const api = new APICore();

const getInsuranceDiscounts = (params?: GetInsuranceDiscountParams) => {
    const url = `${INSURANCE_URL}/insurance-discounts`;
    return api.get(url, params);
};

const createInsuranceDiscount = (params: CreateInsuranceDiscountParams) => {
    return api.create(`${INSURANCE_URL}/insurance-discounts`, params);
};

const updateInsuranceDiscount = (discountId: string, params: UpdateInsuranceDiscountParams) => {
    const relativeUrl = `/insurance-discounts/${discountId}`;
    return api.update(`${INSURANCE_URL}${relativeUrl}`, params);
};

const deleteInsuranceDiscount = (discountId: string) => {
    const relativeUrl = `/insurance-discounts/${discountId}`;
    return api.delete(`${INSURANCE_URL}${relativeUrl}`);
};

const getUniqueValues = (field: string) => {
    return api.get(`${INSURANCE_URL}/insurance-discounts/unique-values`, { field });
};

export { getInsuranceDiscounts, createInsuranceDiscount, updateInsuranceDiscount, deleteInsuranceDiscount, getUniqueValues };
